import { ImageTag } from 'components'
import s from './styles.module.scss'

export default function Main(props) {
  const aadhaarVerificationStatus = props.aadhaarVerificationStatus
  const aadhaarCard = props.aadhaarCard

  return (
    <div className={s.main}>
      <div className={s.image}>
        <div className={s.imageActions} title='Upload Image'>
          <label htmlFor='imageUpload' className={s.uploadButton}>
            <span className='material-icons-outlined'>photo_camera</span>
          </label>
          <input
            type='file'
            id='imageUpload'
            accept='image/*'
            onChange={props.handleUserLogoChange}
            style={{ display: 'none' }}
          />
        </div>
        <ImageTag src={props.userLogoUrl} alt='' />
        {aadhaarCard && (
          <div className={s.verificationTicks}>
            {(aadhaarVerificationStatus === 'Approved' || aadhaarVerificationStatus === 'approved') ? (
              <>
                <span className={`${s.tick} ${s.tick1}`} title='Aadhaar Verified'>
                  ✓
                </span>
                <span className={`${s.tick} ${s.tick2}`} title='Identity Verified'>
                  ✓
                </span>
              </>
            ) : (
              <span className={`${s.tick} ${s.tickPending}`} title='Aadhaar Verification Pending'>
                ✓
              </span>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
